import script from "./QueueDefaultWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueueDefaultWidget.vue?vue&type=script&setup=true&lang=ts"

import "./QueueDefaultWidget.vue?vue&type=style&index=0&id=2047155c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2047155c"]])

export default __exports__